import * as React from "react";

function SvgMixpanel(props, ref) {
  return (
    <svg viewBox="0 0 140 140" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#587DA9"
        d="M0 0h140v140H0V0z"
      />
      <g fill="#FFF">
        <ellipse cx={75.1} cy={106.7} rx={6.7} ry={7.2} />
        <ellipse cx={99.8} cy={106.3} rx={3.8} ry={4.1} />
        <ellipse cx={45.9} cy={106.3} rx={9.6} ry={10.4} />
        <path d="M103.5 77.3V50.4c0-12.3-5.8-19.3-15.4-19.3-6.7 0-11.3 3.5-14.8 8.9-2.3-5.3-6.8-8.9-13.2-8.9-6.7 0-10.6 4.2-13.4 8.7v-2.4c0-3.2-2.2-5.8-5.1-5.8-2.8 0-5 2.6-5 5.8v39.9c0 3.2 2.2 5.7 5 5.7s5.1-2.5 5.1-5.7V54.1c0-7.7 3.8-12.5 9.4-12.5 5.6 0 8.9 4.4 8.9 12.2v23.5c0 3.2 2.2 5.7 5.1 5.7 2.7 0 5-2.5 5-5.7V54.1c0-8.1 3.9-12.5 9.4-12.5 5.7 0 8.9 4.3 8.9 12.3v23.4c0 3.2 2.2 5.7 5.1 5.7 2.8 0 5-2.4 5-5.7z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgMixpanel);
